import React from 'react';
import Fieldset from './Fieldset';
import ToggleSwitch from './ToggleSwitch';

interface ToggleSwitchFieldsetProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  labelStacked?: boolean;
  hint?: React.ReactNode;
  hintClassName?: string;
  hintId?: string;
  hintHidden?: boolean;
  disabled?: boolean;
  name?: string;
  className?: string;
  htmlFor?: string;
  fieldsetClassName?: string;
}

const ToggleSwitchFieldset = React.forwardRef<HTMLInputElement, ToggleSwitchFieldsetProps>(
  (
    {
      id,
      checked,
      onChange,
      label,
      labelStacked,
      hint,
      hintClassName,
      hintId,
      hintHidden,
      disabled,
      name,
      className = '',
      htmlFor,
      fieldsetClassName,
    },
    ref
  ) => {
    const resolvedHtmlFor = htmlFor ?? id;
    return (
      <Fieldset id={id} htmlFor={resolvedHtmlFor} fieldsetClassName={fieldsetClassName}>
        <ToggleSwitch
          ref={ref}
          id={id}
          checked={checked}
          onChange={onChange}
          label={label}
          labelStacked={labelStacked}
          hint={hint}
          hintClassName={hintClassName}
          hintId={hintId}
          hintHidden={hintHidden}
          disabled={disabled}
          name={name}
          className={className}
        />
      </Fieldset>
    );
  }
);

ToggleSwitchFieldset.displayName = 'ToggleSwitchFieldset';

export default ToggleSwitchFieldset;
